<template>
  <div class="pinwall__comment">
    <label class="label">Comments</label>
    <b-field>
      <TextEditor ref="textEditor" @update="textUpdated"></TextEditor>
    </b-field>
    <b-button
      :disabled="!user || text === ''"
      @click="create"
      icon-left="plus"
      :title="
        !user ? $t('buttons.addCommentDisabled') : $t('buttons.addComment')
      "
      class="button is-success is-rounded action-button"
    >
      {{ $t("buttons.comment") }}
    </b-button>
    <ul
      v-if="filteredComments && filteredComments.length > 0"
      ref="messageContainer"
    >
      <li v-for="comment in filteredComments" :key="comment.id">
        <div class="details">
          <UserImage
            :src="comment.userImg"
            :username="comment.username"
            :view="'comment'"
          />
          <div class="meta">
            <div class="date">
              <p>{{ `${getTime(comment)}` }}</p>
            </div>
            <div class="text">
              <p v-html="comment.text" v-linkified></p>
            </div>
          </div>
          <b-button
            v-if="comment.editable"
            @click="remove(comment)"
            class="delete-button"
            :title="$t('delete')"
            type="is-text"
            icon-left="delete"
          ></b-button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TextEditor from "../core/TextEditor";
import { getTimeAgoString } from "../../utils/helpers";
import UserImage from "../core/UserImage.vue";

export default {
  name: "comment",
  data: () => {
    return {
      text: ""
    };
  },
  props: {
    pinwallId: {
      type: String
    },
    postId: {
      type: String
    }
  },
  components: {
    TextEditor,
    UserImage
  },
  computed: {
    ...mapGetters(["user", "comments"]),
    filteredComments() {
      return this.comments.filter(comment => {
        return this.postId
          ? comment.postId === this.postId
          : comment.pinwallId === this.pinwallId && comment.postId === "";
      });
    }
  },
  methods: {
    ...mapActions(["createComment", "deleteComment"]),
    textUpdated(value) {
      this.text = value;
    },
    create() {
      this.createComment({
        pinwallId: this.pinwallId,
        postId: this.postId,
        text: this.text
      }).then(() => {
        this.$refs.textEditor.editor.clearContent();
      });
    },
    remove(comment) {
      this.deleteComment(comment);
    },
    getTime(item) {
      return getTimeAgoString(item.createDate, this.$t("time"));
    }
  }
};
</script>
